<template>
   <div class="home" @intersect="navBarChanger">
       <Observer
               @intersect="navBarChanger('intro'), progressBar(2)"
       />
     <!------------------------------------------------ HEADER ----------------------------------------------->
    <Header></Header>

    <!------------------------------------------------  SECTION INTRO/FIRST SCREEN  ----------------------------------------------->

    <section class="first-screen" id="intro">
        <img src="img/entete/entete.jpg" alt="entete site" class="entete"/>
            <h1 class="titre" id="bloctitre_text_1">
                L'ARNAQUE
            </h1>
            <h1 class="titre" id="bloctitre_text_2">
                QUI VALAIT
            </h1>
            <img src="img/entete/cinqcinq.svg" alt="5,5" id="image_titre">
            <h1 class="titre" id="bloc_titre_text_3">
                MILLIARDS
            </h1>

      <p class="date">
        Données de l'enquête mises à jour le <br />{{ this.$store.state.date }}<br />
        de manière automatisée
      </p>
      <p class="introduction">
        A la recherche d’une belle opération financière ou d'une alternative au
        système bancaire, des milliers d’internautes se sont laissés berner par
        des promesses de placements juteux sur le bitcoin, le
        «forex» et autres grands crûs viticoles. Des produits financiers
        totalement factices. Nées à la fin des années 2000, ces escroqueries
        font un malheur. En voici les coulisses.
      </p>


    </section>

    <!--------#####################################  FIN FIRST SCREEN / DEBUT CONTENT  ##########################################------------------------->
    <div class="content">
      <!------------------------------------------------  SECTION FRAUDE ENORME  ----------------------------------------------->

      <section id="fraude-enorme" class="fraude-enorme">

        <div class="box_title_chapo">
          <h2 class="title-box">
            L’une des plus grandes fraudes de l’histoire française
            </h2>

            <h5 class="chapo">
              En proposant des placements complètement farfelus sur internet,
              des escrocs lèvent, depuis 10 ans, des sommes considérables.
               Une arnaque bien plus lucrative que la fraude dite au CO2 - 1,6
              milliards d'euros - pourtant surnommée le "casse du siècle".
            </h5>
            <Observer
                    @intersect="progressBar(10), navBarChanger('fraude-enorme')"
            />

        </div>
        <div v-if="this.browser!='safari'">
        <Scrollama id ="safari"/>
    </div>
        <div v-else>
          <ScrollamaSafari />
          </div>
           <Observer
                   @intersect="progressBar(15)"
           />

          <div v-if="this.browser!='safari'">
              <Slideshow />
          </div>
          <div v-else>
              <SlidesShowSafari />
          </div>


             <Observer
                   @intersect="progressBar(17)"
           />

             <Cloud />
            <Observer
                   @intersect="progressBar(22)"
           />

           <Wallimages />

           <Observer
                   @intersect="progressBar(30)"
           />
           <Scrollama2 />
          <Observer
                  @intersect="progressBar(35)"
          />



      </section>
         <!---------------------------------------  SECTION MECANIQUE   --------------------------------------->
      <section id="mecanique">

          <Observer
                  @intersect="navBarChanger('mecanique'),progressBar(37)"
          />

        <Mecanique />

      </section>
      <!---------------------------------------  FIN SECTION MECANIQUE   --------------------------------------->

      <!---------------------------------------  SECTION VICTIMES   --------------------------------------->

      <section id="victimes">
        <Observer
          @intersect="navBarChanger('victimes'), progressBar(70)"
        />
        <Victimes />

      </section>
      <!---------------------------------------  FIN SECTION VICTIMES   --------------------------------------->



    </div>

       <Footer />
       <Observer
               @intersect="progressBar(100)"
       />
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Observer from "@/components/Observer.vue";
import Scrollama from "@/components/Scrollama.vue";
import Scrollama2 from "@/components/Scrollama2";
import ScrollamaSafari from "@/components/ScrollamaSafari.vue";
import SlidesShowSafari from "@/components/imagesHandler/SlideshowSafari.vue";
import Victimes from "@/views/Victimes.vue";
import Mecanique from "@/views/Mecanique.vue";
import Slideshow from "@/components/imagesHandler/Slideshow.vue";
import Wallimages from "@/components/imagesHandler/Wallimages.vue";
import Cloud from "@/components/chartsHandler/Cloud.vue"
import Footer from "./Footer";

export default {
  name: "Home",
  components: {
    Header,
    Observer,
    Scrollama,
    Scrollama2,
    Victimes,
    Mecanique,
    Wallimages,
    Slideshow,
    ScrollamaSafari,
    SlidesShowSafari,
    Cloud,
    Footer
  },
  data: function() {
    return {
      browser:'babar',
    };
  },
  created(){
    var _myself = this
    setTimeout(function() {
      if (_myself.$browserDetect.isFirefox){
        _myself.browser = 'firefox'
      }
      else if (_myself.$browserDetect.isSafari){
        _myself.browser ='safari'
       }
      else if (_myself.$browserDetect.isIOS){
          _myself.browser ='safari'
      }
      else if (_myself.$browserDetect.meta.name === 'Safari'){
          _myself.browser ='safari'
      }
    }, 100)

  },
  methods: {
    /*navbarchhanger is a patched in javascript build because navbarcomponent sticky dosen't want to update with the store*/
    navBarChanger(readingStatus) {
      var intro_nav_desktop = document.getElementById("intro-nav")
     /* test du null pour pouvoir arbitrer en une version responsive et une version desktop sans provoquer d'erreurs */

        if (intro_nav_desktop != null){
          intro_nav_desktop.classList.toggle("router-link-active", readingStatus == 'intro');
          if (window.innerWidth<1000){
              intro_nav_desktop.style.fontWeight='700';
              intro_nav_desktop.style.color='#2d3562';
          }

      }


      var  mecanique_nav_desktop = document.getElementById("mecanique-nav")
      if  (mecanique_nav_desktop != null){
          mecanique_nav_desktop.classList.toggle("router-link-active", readingStatus == 'mecanique');
      }

      var  mecanique_nav_mobile = document.getElementById("mecanique-nav-mobile")
        if  (mecanique_nav_mobile != null){
            mecanique_nav_mobile.classList.toggle("router-link-active", readingStatus == 'mecanique');
            intro_nav_desktop.style.fontWeight= '700'
        }

     var fraude_enorme_nav_desktop =  document.getElementById("fraude-enorme-nav")
        if (fraude_enorme_nav_desktop != null){
            fraude_enorme_nav_desktop.classList.toggle("router-link-active", readingStatus == 'fraude-enorme');

        }

     var fraude_enorme_nav_mobile = document.getElementById("fraude-enorme-nav-mobile")
            if (fraude_enorme_nav_mobile != null ){
                fraude_enorme_nav_mobile.classList.toggle("router-link-active", readingStatus == 'fraude-enorme');
                intro_nav_desktop.style.fontWeight= '700'

            }

     var  victimes_nav = document.getElementById("victimes-nav")
         if (victimes_nav != null){
            victimes_nav.classList.toggle("router-link-active", readingStatus == 'victimes');
         }

      var   victimes_nav_mobile =   document.getElementById("victimes-nav-mobile")
            if (victimes_nav_mobile != null){
                victimes_nav_mobile.classList.toggle("router-link-active", readingStatus == 'victimes');
                intro_nav_desktop.style.fontWeight= '700'
            }

    },
    progressBar(percentage){
      var myprogress = document.getElementById("progressbar")
      myprogress.setAttribute("value", percentage)

    }
    },

  };
</script>

<style>


    .entete{
        position:relative;
        max-width:100%;
        max-height:66.89%;
        top:4vh;
    }




    .titre{
        color:#2D3562;
        background-color:white;
    }

    #image_titre {
        margin:0;
        width:25%;
        height:38.9%;
        position:absolute;
        top:36%;
        left:19%;
        z-index:2
    }


    #bloctitre_text_1 {
        margin:0;
        /*max-width:29%;*/
        height:11%;
        position:absolute;
        display:flex;
        justify-content:center;
        align-items:center;
        left:10%;
        top:13%;
        padding:0.5%;
         }








#bloctitre_text_2{
    margin:0;
    height: 11%;
    position:absolute;
    display:flex;
    justify-content:center;
    align-items:center;
    top: 25%;
    left: 13%;
    padding: 0.5%;


}


    #bloc_titre_text_3 {
        position:absolute;
        display:flex;
        justify-content:center;
        align-items:center;
        margin:0;
        height:11%;
        top:62%;
        left:42%;
        padding:0.5%;
    }



    /* RESPONSIVE ------------------- I-PAD*/
@media screen and (max-width: 1000px) {
   #bloctitre_text_1, #bloctitre_text_2, #bloc_titre_text_3 {
       font-size: 24px
   }
    .entete{
        top:5vh;

    }
    #bloctitre_text_1{
        top:22%;
        left:10%;
        padding-left:1%;
        padding-right:1%;
    }
    #bloctitre_text_2{
        top:35%;
        left:20%;
        padding-left:1%;
        padding-right: 1%;
    }
    #image_titre{
        top:44%;
        left:30%;
    }
    #bloc_titre_text_3{
        top:69%;
        left:53%;
        padding-left:1%;
        padding-right: 1%;

    }


}

    /* RESPONSIVE ------------------- i-phone-plus*/

    @media screen and (max-width: 600px) {
        .entete {
            top:6vh;
        }
        #bloctitre_text_1{
            top:33%;
            left:5%;
            padding:1%;
        }
        #bloctitre_text_2{
            top:47%;
            left:10%;
            padding:1%;
        }
        #image_titre{
            top:60%;
        }
        #bloc_titre_text_3{
            top:85%;

        }

    }




    /* RESPONSIVE ------------------- i-phone6*/
    @media screen and (max-width: 430px) {
        .entete {
            top:6vh;
        }
        #bloctitre_text_1{
            top:33%;
            left:5%;
            padding:1%;
        }
        #bloctitre_text_2{
            top:47%;
            left:10%;
            padding:1%;
        }
        #image_titre{
            top:60%;
                    }
        #bloc_titre_text_3{
            top:85%;

        }

    }

    @media screen and (max-width: 400px) {
        .entete {
            top:6vh;
        }
        #bloctitre_text_1{
            top:33%;
            left:5%;
            padding:1%;
        }
        #bloctitre_text_2{
            top:47%;
            left:10%;
            padding:1%;
        }
        #image_titre{
            top:60%;
        }
        #bloc_titre_text_3{
            top:85%;

        }

    }



#container1 {
  height: 400px;
}
</style>